<!-- <div class="m-t10 flex-row-end"><gp-pvfv-setting></gp-pvfv-setting></div> -->
<highcharts-chart  
    [Highcharts] = "Highcharts"
    [options]="options"  
    style="width: 100%; height: 95%; display: block;">
</highcharts-chart>         
   

<!-- <highcharts-chart  
    [Highcharts] = "Highcharts"
    [options]="options"  
    [callbackFunction]="chartCallBack" 
    style="width: 100%; height: 95%; display: block;">
</highcharts-chart>             -->

